"use client"

import { ForwardedRef, forwardRef, PropsWithChildren } from "react"

import { useParams } from "next/navigation"
import NextLink from "next/link"

import { classNames as typographyClassNames, TypographyProps } from '@/components/Typography'

const Link = forwardRef((props: LinkProps, ref: ForwardedRef<any>) => {

    const {
        href,
        absolute,
        override,
        className,
        variant = 'p',
        active,
        ariaLabel,
        external,
        ...rest
    } = props

    const { locale } = useParams()

    const src = absolute ? href : `${process.env.NEXT_PUBLIC_DOMAIN}/${locale}${href}`
    // const src = `${process.env.NEXT_PUBLIC_DOMAIN}/${locale}${href}`

    if (!src) {
        return <></>
    }

    const linkProps: any = {
        ...rest,
        'href': src,
        'className': override ? `${typographyClassNames[variant]} ${className} hover:underline decoration-white underline-offset-2`: className,
        'aria-label': ariaLabel
    }

    if (!src?.includes(process.env.NEXT_PUBLIC_DOMAIN || '')) {
        linkProps['target'] = 'blank'
        linkProps['rel'] = 'noopener'
    }

    return (
        <NextLink {...linkProps} />
    )

})

export type LinkProps = Partial<PropsWithChildren<{
    href: string
    id?: string
    absolute?: boolean
    override?: boolean
    className?: string
    target?: string
    variant?: TypographyProps['variant']
    disabled?: boolean
    active?: boolean
    ariaLabel?: string
    external?: boolean
}>>

export default Link